/** @beta */
export type TransformStep = {
  transformStep: number;
};
/** @beta */
export type Indexed = {
  transformStep: number;
};
// TASK LIST: [TODO: Types] (Review Documentation) -------------------
